import {
    COMPLAIN_LIST_FAILED, COMPLAIN_LIST_LOADDATA, COMPLAIN_LIST_LOADING,
    COMPLAIN_LIST_SUCCESS

} from "../constants/ComplainlistConst";


const initState = {
    loading: false,
    message: '',
    showMessage: false,
    id: 0,
    data: []
}

const complainlistreducer = (state = initState, action) => {
    switch (action.type) {
        case COMPLAIN_LIST_LOADING:
            return {
                ...state,
                loading: true,
            }
        case COMPLAIN_LIST_FAILED:
            return {
                ...state,
                message: action.message,
                showMessage: true,
                loading: false,
                stages_loading: false,
            }
        case COMPLAIN_LIST_SUCCESS:
            return {
                ...state,
                showMessage: false,
                data:action.data,
                loading: false
            }
        case COMPLAIN_LIST_LOADDATA:
            return {
                ...state,
                loading: true,
            }


        default:
            return state;
    }
}

export default complainlistreducer